<div class="kiosk-phone-input-wrapper">
  <!-- Only show flag container if not using local format -->
  <div
    class="flag-container"
    (click)="toggleCountriesList($event)"
    *ngIf="!useLocalFormat()"
  >
    <div class="selected-flag">
      <div class="flag">
        <img
          [src]="selectedIso() | appFn: getFlagIcon"
          [alt]="selectedIso() + ' flag'"
          class="flag-img"
        />
      </div>
      <div class="arrow"></div>
    </div>

    <!-- Country List Container -->
    <div
      class="country-list-container"
      *ngIf="listOpen()"
    >
      <!-- Basic country list -->
      <div
        class="country-list"
        *ngIf="!showExtendedList()"
      >
        <div
          class="country"
          *ngFor="let country of filteredCountries; trackBy: trackByIso"
          (click)="selectCountry(country.iso2); $event.stopPropagation()"
        >
          <div class="country-content">
            <div class="flag-wrapper">
              <div class="flag">
                <img
                  [src]="country.iso2 | appFn: getFlagIcon"
                  [alt]="country.iso2 + ' flag'"
                  class="flag-img"
                />
              </div>
            </div>
            <div class="country-info">
              <div class="country-name">{{ country.name }}</div>
            </div>
            <div class="dial-code">+{{ country.dialCode }}</div>
          </div>
        </div>
        <div
          class="country show-more"
          (click)="showAllCountries(); $event.stopPropagation()"
        >
          <div class="country-name">{{ 'PHONE_INPUT.SHOW_MORE_COUNTRIES' | translate }}</div>
        </div>
      </div>

      <!-- Extended country list with search -->
      <div
        class="extended-country-list"
        *ngIf="showExtendedList()"
      >
        <div class="search-header">
          <button
            class="back-button"
            (click)="backToShortList(); $event.stopPropagation()"
          >
            {{ 'PHONE_INPUT.BACK' | translate }}
          </button>
        </div>

        <div class="countries-container">
          <div
            class="country"
            *ngFor="let country of filteredAllCountries; trackBy: trackByIso"
            (click)="selectCountry(country.iso2); $event.stopPropagation()"
          >
            <div class="country-content">
              <div class="flag-wrapper">
                <div class="flag">
                  <img
                    [src]="country.iso2 | appFn: getFlagIcon"
                    [alt]="country.iso2 + ' flag'"
                    class="flag-img"
                  />
                </div>
              </div>
              <div class="country-info">
                <div class="country-name">{{ country.name }}</div>
              </div>
              <div class="dial-code">+{{ country.dialCode }}</div>
            </div>
          </div>

          <div
            class="no-results"
            *ngIf="filteredAllCountries.length === 0"
          >
            {{ 'PHONE_INPUT.NO_RESULTS' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <input
    type="tel"
    class="phone-input"
    [class.full-width]="useLocalFormat()"
    [ngModel]="displayedPhone()"
    (ngModelChange)="onChangePhone($event)"
    [placeholder]="
      useLocalFormat() && selectedIso() === 'fr'
        ? ('PHONE_INPUT.PLACEHOLDER_WITH_EXAMPLE' | translate)
        : ('PHONE_INPUT.PLACEHOLDER' | translate)
    "
    autocomplete="tel"
  />
</div>
